import axios from "axios";

const configuredApiUrl = (process.env.REACT_APP_CORE_API || '').trim();

// Keep the app functional when the build/deployment does not include a .env file.
// Every route in this project is mounted below /api on the production backend.
export const API_URL = configuredApiUrl || 'https://pos-api.boldestore.com/api';

const appHeaderProperties = {
  Accept: 'application/json',
};

const normalizeRequestData = (data = {}) => {
  if (!data || typeof data !== 'object') {
    return { headers: {}, params: {}, body: data || '' };
  }

  return {
    headers: data.headers || {},
    params: data.params || {},
    body: Object.prototype.hasOwnProperty.call(data, 'data') ? data.data : '',
  };
};

export const apiCall = async ({ method, url, data = {}, baseURL }, navigation) => {
  const request = normalizeRequestData(data);

  try {
    const response = await axios({
      baseURL: baseURL || API_URL,
      method,
      url,
      data: request.body,
      headers: {
        ...appHeaderProperties,
        ...request.headers,
      },
      params: request.params,
      timeout: 30000,
      'axios-retry': {
        retries: 0,
      },
    });

    return response.data;
  } catch (error) {
    const status = error?.response?.status || 0;
    const serverData = error?.response?.data;
    const message =
      serverData?.message ||
      (status === 401
        ? 'Sesi login berakhir. Silakan login kembali.'
        : status === 403
          ? 'Anda tidak memiliki akses ke data ini.'
          : status >= 500
            ? 'Server sedang bermasalah. Silakan coba lagi.'
            : error?.code === 'ECONNABORTED'
              ? 'Koneksi ke server terlalu lama. Silakan coba lagi.'
              : 'Tidak dapat terhubung ke server. Periksa koneksi dan konfigurasi API.');

    // Existing pages expect an object with `status` and `message`.
    // Returning a normalized error prevents Select/Search data loaders from
    // silently crashing with "Cannot read properties of undefined".
    return {
      status,
      message,
      data: serverData?.data ?? null,
      error: true,
    };
  }
};
